<div class="uw-heading-row">
  <span class="uw-heading">
    {{ vm().title | translate }}
  </span>
  @if (vm().badge) {
    <span class="sso-badge">
      <i class="fas fa-shield-alt"></i>
      {{ vm().badge | translate }}
    </span>
  }
</div>
@if (vm().subTitle) {
  <span class="uw-sub-heading">
    {{ vm().subTitle | translate }}
  </span>
}

<div class="mb-2">
  <a tabindex="0" style="color:black" backButton>
    <span>←</span>
    {{ "theme.back" | translate }}
  </a>
</div>
